import React from 'react';
import { object } from 'prop-types';
import Users from './users';
import { userModuleTypes } from '../src/utils/misc';

const OperUsers = ({ session }) => <Users session={session} type={userModuleTypes[2]} />;

OperUsers.propTypes = {
    session: object
};

export default OperUsers;
